import { motion } from "framer-motion";
import { Facebook, Twitter, Instagram, Linkedin, GitPullRequest } from "lucide-react";
import { Logo } from "@/components/ui/logo";
import { fadeIn } from "@/lib/animations";

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.1 }}
        variants={{
          hidden: {},
          show: {
            transition: {
              staggerChildren: 0.15,
            },
          },
        }}
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12"
      >
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <motion.div
            variants={fadeIn("right", "tween", 0.2, 1)}
            className="col-span-1 md:col-span-2"
          >
            <div className="flex items-center text-2xl font-light mb-4">
              <Logo className="h-8 w-auto mr-2" />
              Vettor.ai
            </div>
            <p className="text-gray-400 mb-6 max-w-md font-light">
              The premium AI agent workflow for recruiters, transforming how you find, screen, and hire tech, product, and design talent.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">
                <Twitter className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">
                <GitPullRequest className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">
                <Linkedin className="w-6 h-6" />
              </a>
            </div>
          </motion.div>
          
          <motion.div variants={fadeIn("up", "tween", 0.3, 1)}>
            <h3 className="text-lg font-light mb-4 text-violet-300">Company</h3>
            <ul className="space-y-3 font-light">
              <li><a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">About Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">Careers</a></li>
              <li><a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">Blog</a></li>
              <li><a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">Press</a></li>
            </ul>
          </motion.div>
          
          <motion.div variants={fadeIn("up", "tween", 0.4, 1)}>
            <h3 className="text-lg font-light mb-4 text-violet-300">Resources</h3>
            <ul className="space-y-3 font-light">
              <li><a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">Support</a></li>
              <li><a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">Terms of Service</a></li>
              <li><a href="#" className="text-gray-400 hover:text-violet-400 transition-colors">Contact Us</a></li>
            </ul>
          </motion.div>
        </div>
        
        <motion.div
          variants={fadeIn("up", "tween", 0.5, 1)}
          className="mt-12 pt-8 border-t border-gray-800 text-sm text-gray-400"
        >
          <div className="flex flex-col md:flex-row justify-between items-center font-light">
            <div>© {new Date().getFullYear()} Vettor.ai. All rights reserved.</div>
            <div className="mt-4 md:mt-0">
              <a href="#" className="hover:text-violet-400 transition-colors">Privacy Policy</a>
              <span className="mx-2">|</span>
              <a href="#" className="hover:text-violet-400 transition-colors">Terms of Service</a>
              <span className="mx-2">|</span>
              <a href="#" className="hover:text-violet-400 transition-colors">Cookies</a>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </footer>
  );
}
